import type { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

export function HomeSectionHeading({
  icon: Icon,
  eyebrow,
  title,
  description,
  titleId,
  className,
  descriptionClassName,
}: {
  icon: LucideIcon;
  eyebrow: string;
  title: string;
  description: string;
  titleId?: string;
  className?: string;
  descriptionClassName?: string;
}) {
  return (
    <div className={cn(className)}>
      <p className="flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.2em] text-primary">
        <Icon className="h-4 w-4 shrink-0" aria-hidden />
        {eyebrow}
      </p>
      <h2
        id={titleId}
        className="mt-2 text-3xl font-bold tracking-tight text-foreground md:text-4xl"
      >
        {title}
      </h2>
      <p
        className={cn(
          "mt-3 text-base text-muted-foreground leading-relaxed",
          descriptionClassName,
        )}
      >
        {description}
      </p>
    </div>
  );
}
